import React from 'react'
import Button from 'components/Button/Button'
import ChevronLeftIcon from 'icons/ChevronLeft'
import ChevronRightIcon from 'icons/ChevronRight'
import usePagination, { DOTS } from 'hooks/usePagination'
import { TablePaginationProps } from './Table.props'
import {
  TablePaginationContainer,
  TablePaginationItemContainer,
  TablePaginationPage,
} from './Table.styled'

const SIBLING_COUNT = 1
const PAGE_SIZE = 10

const TablePagination = ({
  totalCount,
  currentPage,
  onChangePage,
}: TablePaginationProps) => {
  const paginationRange = usePagination({
    totalCount,
    pageSize: PAGE_SIZE,
    siblingCount: SIBLING_COUNT,
    currentPage,
  })

  const handleNext = () => {
    onChangePage(currentPage + 1)
  }
  const handlePrev = () => {
    onChangePage(currentPage - 1)
  }

  const goToPage = (page: number) => {
    onChangePage(page)
  }

  if (currentPage === 0 || (paginationRange && paginationRange.length < 2)) {
    return null
  }

  const lastPage =
    paginationRange && paginationRange[paginationRange.length - 1]

  return (
    <TablePaginationContainer>
      <Button
        leftIconStyle={{
          width: '1rem',
        }}
        LeftIcon={ChevronLeftIcon}
        preset={'filled'}
        variant={'primary'}
        text={'Previous'}
        size={'small'}
        onClick={handlePrev}
        disabled={currentPage === 1}
        style={{ marginRight: '15px' }}
      />
      <TablePaginationItemContainer>
        {paginationRange &&
          paginationRange.length > 0 &&
          paginationRange.map(pageNumber => {
            if (pageNumber === DOTS) {
              return (
                <TablePaginationPage active={false} key={`dot_${pageNumber}`}>
                  &#8230;
                </TablePaginationPage>
              )
            }
            return (
              <TablePaginationPage
                key={pageNumber}
                active={pageNumber === currentPage}
                onClick={() => {
                  if (typeof pageNumber === 'number') {
                    goToPage(pageNumber)
                  }
                }}>
                {pageNumber}
              </TablePaginationPage>
            )
          })}
      </TablePaginationItemContainer>

      <Button
        rightIconStyle={{
          width: '1rem',
        }}
        RightIcon={ChevronRightIcon}
        onClick={handleNext}
        preset={'filled'}
        variant={'primary'}
        text={'Next'}
        size={'small'}
        disabled={currentPage === lastPage ? true : false}
        style={{ marginLeft: '15px' }}
      />
    </TablePaginationContainer>
  )
}

export default TablePagination
